module.exports = __webpack_public_path__ + "img/baner-11.webp";